<template>
  <div class="homecontainer" :style="' background-color:'+String(backgoundcolor)">
    <!--     <GoodTitle :goodname="goodname" :goodinfo="goodinfo" :fontcolor="fontcolor" />-->
    <div class="home_title">
<!--      <h1 class="serstyle  wow slideInLeft">{{titlename}}</h1>-->
      <h1 class="serstyle  wow slideInLeft"   v-if="type==1">{{titlename}}</h1>
      <h1 class="newstyle  wow slideInLeft"  v-else>{{titlename}}</h1>

      <!--文字栏-->
      <div  class="text_title">
        <button class="button wow slideInRight" v-if="type==1" @click="$router.push('/services')">{{$t('header.Learnmore')}}</button>
        <button class="button wow slideInRight" v-else-if="type==2" @click="$router.push('/facilities')">{{$t('header.Learnmore')}}</button>
        <button class="button wow slideInRight" v-else="type==3" @click="$router.push('/news')" >{{$t('header.Learnmore')}}</button>

      </div>
    </div>
    <img :src="imgsrc"  >
<!--    <div class="imgtype2"  v-show="type==2">-->
<!--      <img :src="imgsrc">-->
<!--    </div>-->
<!--    <div class="imgtype3"  v-show="type==3">-->
<!--      <img :src="imgsrc">-->
<!--    </div>-->

  </div>
</template>

<script>
  import { WOW } from 'wowjs';
    export default {
        name: "Services",
      props: [ 'titlename','imgsrc','backgoundcolor','type'],
      methods: {
        routerpush(to)
        {
          this.$router.push(to)
        },
      },
      mounted(){
        //解决---控制台可能会出现警告
        var options={
          //默认为true
          live:false
        }
        var wow = new WOW(options);
        wow.init();
      },
    }
</script>

<style lang="less" scoped>
  // 大于800px
  @media only screen and (min-width: 800px) {
    .homecontainer {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      min-height: 500px;
      font-size: 1em;
      margin-top: -20%;
      z-index: 999;
      /*margin-bottom: 13px;*/

      .home_title {
        position: absolute;
        top: 6%;
        left: 50%;
        width: 70%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;
        font-size: 1.8em;
        z-index: 999;

        .newstyle {
          font-size: 2em;
          color: white;
          margin-top: 14%;
        }

        .serstyle {
          margin-top: 13%;
          font-size: 2em;
          color: white;
        }
        .text_title{
          padding-top: 45%;
        }

        h1 {
          font-size: 2.2em;
        }

        .button {
          background: rgba(0, 0, 0, 0);
          border: 1.5px solid white;
          color: white;
          padding: 5% 2vw;
          text-align: center;
          text-decoration: none;
          display: inline-block;
          font-size: 0.8em;
          transition: all 0.4s; //设置动画执行的时间为0.6s
          cursor: pointer;
        }

        .button:hover {
          transform: scale(0.9);
        }
      }

      img {
        width: 100%;
        /*height: 52vw !important;*/
        height: auto;
      }
    }
  }
  // 小于800px
  @media only screen and (max-width: 800px){
    .homecontainer {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      font-size: 1em;
      margin-top: -23%;
      /*margin-bottom: 13px;*/

      .home_title {
        position: absolute;
        top: 3%;
        left: 50%;
        width: 70%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;
        font-size: 2em;
        z-index: 999;

        .newstyle {
          font-size: 2em;
          color: white;
          margin-top: 10%;
        }

        .serstyle {
          margin-top: 10%;
          font-size: 2em;
          color: white;
        }
        .text_title{
          padding-top: 40%;
        }

        h1 {
          font-size: 2.4em;
        }

        .button {
          background: rgba(0, 0, 0, 0);
          border: 1.5px solid white;
          color: white;
          padding: 5% 2vw;
          text-align: center;
          text-decoration: none;
          display: inline-block;
          font-size: 0.8em;
        }
      }

      img {
        width: 100%;
        height: auto;
        z-index: 99;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home/homecomponents/services_home.vue